import type { AIChatContentSegment } from '../../features/bidResponse/components/assistant/types/aiChatContentSegment.types';
import type { User } from './User';

export type AssistantThreadMessage = AssistantLlmMessage | AssistantUserMessage;

type AssistantThreadMessageBase = {
  id: number;
  content: AIChatContentSegment[];
};

export type AssistantLlmMessage = AssistantThreadMessageBase & {
  role: AssistantThreadMessageRole.ASSISTANT;
  owner: null;
  filters: null;
};

export type AssistantUserMessage = AssistantThreadMessageBase & {
  role: AssistantThreadMessageRole.USER;
  owner: Pick<User, 'id' | 'firstName' | 'lastName' | 'avatarColor'>;
  filters: AssistantThreadFilters | null;
};

export enum AssistantThreadMessageRole {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}

export type AssistantThreadFilters = {
  documentTypes?: string[];
  optionIds?: number[];
};
